export default __webpack_public_path__ + "../staticImages/medaille-260.png";